import { render, staticRenderFns } from "./ConfirmationRemoveItem.vue?vue&type=template&id=f026eb54&scoped=true"
import script from "./ConfirmationRemoveItem.vue?vue&type=script&lang=js"
export * from "./ConfirmationRemoveItem.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationRemoveItem.vue?vue&type=style&index=0&id=f026eb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f026eb54",
  null
  
)

export default component.exports